import usePageTitle from '@/hooks/use-page-title';
import {Link, Route, Routes} from "react-router-dom";
import { ChevronRight } from 'lucide-react';
import SmallSpinner from '@/components/shared/spinners/small-spinner';
import { useContracts } from '@/hooks/api/use-contracts';
import { useCurrentUser } from '@/hooks/api/use-user';
import { hasContractApporteur43397, hasOnlyContractApporteur43397 } from '@/lib/contracts';
import ContactezNous from "@/pages/contact/contactez-nous";
import PromoBlocs from '@/pages/home/promo-blocs';
import { HOST_MB } from '@/lib/constants';

const Contact = () => {
    usePageTitle('Contact');
    const contractsQuery = useContracts();
    const user = useCurrentUser();
    const isEligibleParrainage = user.eligible_parrainage;

    if (contractsQuery.isPending) return <SmallSpinner />;

    const contracts = contractsQuery.data?.data ?? [];
    const subscribeLinks = user.prefilled_subscribe_links || {};

    return (
        <div className="w-full">
            <nav className="flex items-center gap-1.5 text-xs sm:text-sm text-muted-foreground mt-4" aria-label="Fil d'Ariane">
                <Link to="/" className="hover:text-foreground transition-colors no-underline">Mon espace</Link>
                <ChevronRight className="w-3 h-3 sm:w-3.5 sm:h-3.5" />
                <Link to="/contact" className="hover:text-foreground transition-colors no-underline">Obtenir de l'aide</Link>
            </nav>
            <div className="space-y-2 sm:space-y-3 mt-4">
                <h1 className="text-xl sm:text-2xl font-bold">Obtenir de l'aide</h1>
            </div>

            <Routes>
                <Route index element={
                    <ContactezNous
                        contracts={contracts}
                        subscribeLinks={subscribeLinks}
                        hasApporteur43397={hasOnlyContractApporteur43397(contracts)}
                        hasContractApporteur43397={hasContractApporteur43397(contracts)}
                    />
                } />
            </Routes>

            {HOST_MB === 43397 && <div className="mt-6"><PromoBlocs isEligibleParrainage={isEligibleParrainage} /></div>}
        </div>
    );
};

export default Contact;
